/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(3);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _styleguide = __webpack_require__(4);

	var _styleguide2 = _interopRequireDefault(_styleguide);

	var _tabsBlock = __webpack_require__(5);

	var _tabsBlock2 = _interopRequireDefault(_tabsBlock);

	var _contactForm = __webpack_require__(6);

	var _contactForm2 = _interopRequireDefault(_contactForm);

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	var _backToTop = __webpack_require__(7);

	var _backToTop2 = _interopRequireDefault(_backToTop);

	var _thankyouMessage = __webpack_require__(8);

	var _thankyouMessage2 = _interopRequireDefault(_thankyouMessage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Styleguide
		_styleguide2.default.init();

		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Tabs block
		_tabsBlock2.default.init();

		// Contact form
		_contactForm2.default.init();

		// Global
		_global2.default.pluginsCall();

		// Back to top
		_backToTop2.default.init();

		// Thank you message
		_thankyouMessage2.default.init();

		AOS.init({
			// disable: 'mobile',
		});
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict';
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.menu-item-has-children'),
		$domNavigation: $('.js-site-header'),

		$domUpperMenuItems: $('.js-site-header__flex-wrapper'),
		$domUpperMenuItemsContainer: $('.js-site-header__upper'),
		$domMenu: $('.primary-menu'),
		$domSubIcon: $('.sub-icon'),
		$domSiteContent: $('.site-content'),

		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSiteScroll: 'site-header__scroll',
		classSiteContentMod: 'site-content--mod',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// functions
			function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			}

			if (_global2.default.varsWindowWidth < 991) {
				this.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-chevron-down" data-open-sub></span>');
				});
			}

			// bind events
			this.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen);
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			this.$domMenuNav.on('click', '[data-open-sub]', function () {
				if (_global2.default.varsWindowWidth < 991) {
					$(this).siblings('.sub-menu').slideToggle();
				}
			});

			function appendIconsMenu() {
				if (window.innerWidth < 991) {
					Menu.$domUpperMenuItems.appendTo(Menu.$domMenu);
				} else {
					Menu.$domUpperMenuItems.appendTo(Menu.$domUpperMenuItemsContainer);
				}
			}

			$(window).on('resize', function () {
				appendIconsMenu();
			});

			//Nav on scroll
			$(document).on('scroll', function () {
				var scrollTop = $(document).scrollTop();
				if (scrollTop > 0 && $(window).width() >= 991) {
					Menu.$domNavigation.addClass(Menu.classSiteScroll);
					Menu.$domSiteContent.addClass(Menu.classSiteContentMod);
				} else {
					Menu.$domNavigation.removeClass(Menu.classSiteScroll);
					Menu.$domSiteContent.removeClass(Menu.classSiteContentMod);
				}
			});

			appendIconsMenu();

			_global2.default.functions.clickOutsideContainer(this.$domMenuNav, this.$domMenuNav.children('ul'), this.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}

		},

		pluginsCall: function pluginsCall() {
			// Select2 Call
			$('select').select2({
				minimumResultsForSearch: -1,
				width: 'style'
			});
		}

	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// slider
			this.$domSlider.slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}]
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict';
	var Styleguide = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domStyleNavWrap: $('.js-styleguide-nav-wrap'),
		$domStyleNav: $('.js-styleguide-nav'),
		$domStyleSection: $('.js-styleguide-section'),
		$domStyleNavClose: $('.js-styleguide-close'),
		selectorStyleNav: '.js-styleguide-nav',
		classHidden: 'is-hidden',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var _this = this;

			if (this.$domStyleNav.length) {
				this.$domStyleSection.each(function (i, el) {
					var navItem = '<li><a class="list-group-item" href="#section-' + i + '">' + $(el).attr('data-section-title') + '</a></li>';

					_this.$domStyleNav.append(navItem);
				});

				_global2.default.$domBody.scrollspy({ target: this.selectorStyleNav });

				this.scrollTo('.list-group-item');

				this.$domStyleNavClose.on('click', function () {
					_this.$domStyleNavWrap.addClass(_this.classHidden);
				});
			}
		},

		scrollTo: function scrollTo(selector) {
			$(selector).on('click', function (e) {
				e.preventDefault();
				var target = $(this.hash);

				if (target.length) {
					$('html,body').animate({
						scrollTop: target.offset().top
					}, 1000);
					return false;
				}
			});
		}
	};

	exports.default = Styleguide;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* always include jQuery in this manner in every file where jQuery is used  */
	var $ = jQuery.noConflict();

	/* import Global or some other files only if you need them */


	'use strict';
	var TabsBlock = {
	    /*-------------------------------------------------------------------------------
	    	# Cache dom and strings
	       -------------------------------------------------------------------------------*/
	    $domTabs: $('.js-component-tabs-block__tab'),
	    $domTabSmaller: $('.js-component-tabs-block__tab--smaller'),
	    $domTabBigger: $('.js-component-tabs-block__tab--bigger'),
	    $domContentSmall: $('.js-component-tabs-block__tabs-content-wrap-small'),
	    $domContentBig: $('.js-component-tabs-block__tabs-content-wrap-big'),
	    $domTabContent: $('.js-component-tabs-block__tabs-content-wrap'),

	    classTabBigger: 'js-component-tabs-block__tab--bigger',
	    classActiveContent: 'component-tabs-block__tab-content-wrap--active',
	    classActiveTab: 'component-tabs-block__tab--active',

	    /*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        TabsBlock.$domTabs.on('click', function (e) {
	            TabsBlock.$domTabs.removeClass(TabsBlock.classActiveTab);
	            $(this).addClass(TabsBlock.classActiveTab);

	            if ($(this).hasClass(TabsBlock.classTabBigger)) {
	                TabsBlock.$domTabContent.removeClass(TabsBlock.classActiveContent);
	                TabsBlock.$domContentBig.addClass(TabsBlock.classActiveContent);
	            } else {
	                TabsBlock.$domContentBig.removeClass(TabsBlock.classActiveContent);
	                TabsBlock.$domContentSmall.addClass(TabsBlock.classActiveContent);
	            }
	        });
	    }
	};

	exports.default = TabsBlock;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* always include jQuery in this manner in every file where jQuery is used  */
	var $ = jQuery.noConflict();

	/* import Global or some other files only if you need them */


	'use strict';
	var ContactForm = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		strCF7Holder: '.js-cf7-holder',
		strForm: '.wpcf7-form',
		strTriggerURL: '/contact-us/#wpcf7-f36-o1',
		classSent: 'form-is-sent',
		classInvalid: 'invalid',
		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			this.afterFormSubmit();
			this.checkIfIE();
			if ($('select.wpcf7-form-control option').length > 0) {
				var optionSel = $('select.wpcf7-form-control option');
				optionSel[0].setAttribute('disabled', true);
				optionSel[0].setAttribute('selected', true);
			}
		},
		afterFormSubmit: function afterFormSubmit() {
			var formHolder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-cf7-holder';
			var sentClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form-is-sent';
			var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;

			document.addEventListener('wpcf7mailsent', function (e) {
				/* const formId = e.detail.id; */
				var formId = e.target;
				/* console.log(formId); */

				/* $(`#${formId}`).parents(formHolder).addClass(sentClass); */
				$(formId).parents(formHolder).addClass(sentClass);

				setTimeout(function () {
					$(formHolder).removeClass(sentClass);
				}, delay);
			}, false);
		},
		// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
		checkIfIE: function checkIfIE() {
			var url = window.location.href;
			if (url.indexOf(ContactForm.strTriggerURL) > -1 && !$(ContactForm.strForm).hasClass(ContactForm.classInvalid)) {
				$(ContactForm.strForm).parents(ContactForm.strCF7Holder).addClass(ContactForm.classSent);
				setTimeout(function () {
					$(ContactForm.strCF7Holder).removeClass(ContactForm.classSent);
				}, 5000);
			}
		}
	};

	exports.default = ContactForm;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* always include jQuery in this manner in every file where jQuery is used  */
	var $ = jQuery.noConflict();

	/* import Global or some other files only if you need them */


	'use strict';
	var BackToTop = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domBackToTop: $('.js-site-footer_back-to-top'),

		classBackToTopActive: 'site-footer_back-to-top--active',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			BackToTop.$domBackToTop.on('click', function () {
				$("html, body").animate({ scrollTop: 0 }, 1000);
			});

			//Toggles back to top button, after 5000px
			$(document).on('scroll', function () {
				if ($(document).scrollTop() > 2000) {
					BackToTop.$domBackToTop.addClass(BackToTop.classBackToTopActive);
				} else {
					BackToTop.$domBackToTop.removeClass(BackToTop.classBackToTopActive);
				}
			});
		}
	};

	exports.default = BackToTop;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Message = {
	    /*-------------------------------------------------------------------------------
	    	# Cache dom and strings
	    -------------------------------------------------------------------------------*/
	    $domSubmit: $('.wpcf7 input[type="submit"]'),
	    $closeBtn: $('.js-thank-you-block__close'),

	    /*-------------------------------------------------------------------------------
	    	# Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        $(".wpcf7").on('mailsent.wpcf7', function (e) {
	            $('.thank-you-block').appendTo($(this));
	            $('.wpcf7-response-output.wpcf7-mail-sent-ok').appendTo($('.thank-you-block'));
	            $('.thank-you-block').fadeIn('slow');
	            var thankYou = $(this).find('.thank-you-block');
	            $("html, body").animate({
	                scrollTop: $(thankYou).offset().top - 200
	            }, 1000);
	        });

	        $(".wpcf7").on('invalid.wpcf7', function (e) {
	            var allErrors = $(this).find('.wpcf7-not-valid-tip');
	            $("html, body").animate({
	                scrollTop: $(allErrors).eq(0).offset().top - 220
	            }, 500);
	        });

	        Message.$closeBtn.on('click', function () {
	            $('.thank-you-block').fadeOut('slow');
	        });
	    }
	};

	exports.default = Message;

/***/ })
/******/ ]);